import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaUserPlus, FaUsers, FaSearch, FaHeart, FaHome } from 'react-icons/fa';

const Navigation = () => {
    const location = useLocation();
    
    const isActive = (path) => {
        return location.pathname === path;
    };
    
    return (
        <nav className="bg-gradient-to-r from-red-600 via-red-500 to-blue-600 shadow-xl">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    {/* Logo/Brand */}
                    <div className="flex items-center space-x-2">
                        <FaHeart className="text-white text-2xl animate-pulse" />
                        <Link to="/" className="text-white font-bold text-xl tracking-wide">
                            Bihebari<span className="text-yellow-300"></span>
                        </Link>
                    </div>
                    
                    {/* Navigation Links */}
                    <div className="flex space-x-1">
                        <Link
                            to="/register"
                            className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
                                isActive('/register') 
                                    ? 'bg-white text-red-600 shadow-lg' 
                                    : 'text-white hover:bg-white/20 hover:scale-105'
                            }`}
                        >
                            <FaUserPlus className="text-base" />
                            <span>Register</span>
                        </Link>
                        
                    
                        
                     
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navigation;